import { gql } from '@apollo/client'

export default gql(`
query($id: ID! $project: String) {
    getAsset(
        id: $id
        project: $project
    ) {
        id
        markInTime
        markOutTime
        drmRequired
        site
    }
}`)
